import MenuItem from '@/ui/header-navigation/MenuItem';
import {headerNavMenuData} from '@/content';
import styles from '@/ui/header-navigation/MegaMenu.module.scss';

const MegaMenu = ({handleToggle, clicked, setIsDrawerOpen}) => {


    return (
        <div className={styles.navContainer}>
            <nav>
                <ul>
                    {headerNavMenuData.map(({label, href, icon, children}, index) => (
                        <MenuItem
                            key={index}
                            {...{
                                label,
                                href,
                                icon,
                                children,
                                setIsDrawerOpen,
                            }}
                            onToggle={() => handleToggle && handleToggle(index)}
                            active={clicked === index}
                        />
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default MegaMenu;
